<template>
  <slot name="table">
    <div class="w-full h-full">
      <template v-if="!options.loading">
        <slot name="body" v-bind="options">
          <div
            v-for="(row, index) in options.rows"
            :key="index" class="grid sm:grid-cols-1 md:grid-cols-4 lg:grid-cols-4 gap-1 bg-white p-1 px-3 m-3 border border-gray-400 dark:border-gray-700 rounded-xl dark:bg-slate-900">
            <div v-if="options.columnChecked" class="py-3 ps-4">
              <div class="flex items-center">
                <InputDefault
v-model="options.seleccionados" :value="(row as any)[options.columnChecked]"
                  type="checkbox"
                  class="border-gray-400 rounded text-blue-600 focus:ring-blue-500 dark:bg-neutral-700 dark:border-neutral-500 dark:checked:bg-blue-500 dark:checked:border-blue-500 dark:focus:ring-offset-gray-800">
                </InputDefault>
              </div>
            </div>
            <template v-for="col in options.columns" :key="'COL_'+col.label">
              <div v-if="col.name != 'Action'" :class="col.class ?? ' sm:col-span-1 '">
                <slot :name="col.name" v-bind="{ row, col }">
                  <div v-if="col.html" class="px-1 py-3" v-html="col.html(row)">
                  </div>
                  <div v-else-if="col.component" class="px-1 py-3">
                    <component :is="col.component(row)" />
                  </div>
                  <div v-else class="px-1 py-3">
                    <span class="text-sm font-semibold text-gray-600 dark:text-gray-200">{{
                      col.mapValue ? col.mapValue(row) : (row as any)[col.name] }}</span>
                  </div>
                </slot>
              </div>
              <div v-else :class="col.class + ' flex justify-center items-center'">
                <slot :name="col.name" v-bind="{ row, col, rows: options.rows, iconos, expanded }">
                  <template v-for="(btn, indexb) in col.btns" :key="indexb">
                    <TooltipDefault
                    :id="`${options.identification}_BTN_${index}_${indexb}`"
                    :description="btn.description"
                    :label="btn.label"
                    >
                      <template v-if="btn.expanded">
                        <button
                        v-if="!btn.show || (btn.show && btn.show(row))"
                        :key="typeof btn.label === 'function' ? btn.label(row) : btn.label"
                        :class="btn.class"
                        class="hs-tooltip-toggle"
                        type="button"
                        @click="expanded(row)"
                        >
                          <component
                          :is="iconos[btn.icon as IconName]"
                          v-if="btn.icon"
                          class="shrink-0 size-4"
                          />
                          <template v-if="btn.label">
                            {{ btn.label }}
                          </template>
                        </button>
                      </template>
                      <template v-else>
                        <button
                        v-if="!btn.show || (btn.show && btn.show(row)) && btn.label"
                        :key="typeof btn.label === 'function' ? btn.label(row) : btn.label"
                        class="hs-tooltip-toggle"
                        :class="btn.class"
                        type="button"
                        @click="btn.click(row)"
                        >
                          <component
                          :is="iconos[btn.icon as IconName]"
                          v-if="btn.icon"
                          class="shrink-0 size-4"
                          >
                          </component>
                          <template v-if="btn.label">
                            {{ btn.label }}
                          </template>
                        </button>
                      </template>
                    </TooltipDefault>
                  </template>
                </slot>
              </div>
            </template>
            <slot name="details" v-bind="{ row, isExpanded,expanded }">
              <div
              v-if="options.getDetails"
              class="px-1 py-3"
              v-html="options.getDetails(row)"
              >
              </div>
            </slot>
          </div>
        </slot>
      </template>
      <slot name="loading-data">
        <SimpleSkeleton
        v-if="options.loading" class="p-5"
          :options="getSkeleton(1, 10, { anchoC: 'width:100%', anchoF: 'width:100%', altoF: 'h-20' })" />
      </slot>
      <slot name="no-data">
        <div :class="(!options.loading && options.rows.length == 0) ? 'px-3 ' : 'px-3 hidden'">
          <alert-default icono="MagnifyingGlassIcon" :color="'blue'" texto="" titulo="Sin resultados">
          </alert-default>
        </div>
      </slot>
      <div
        class="px-6 py-3 grid gap-3 md:flex md:justify-between md:items-center bg-white border border-gray-400 dark:border-gray-700 p-4 m-3 rounded-xl dark:bg-slate-900">
        <div class="md:hidden">
          <div class="text-sm text-gray-600 dark:text-gray-400 grid grid-cols-2 justify-center items-center">
            <div>Pagina <span class="font-semibold text-gray-800 dark:text-gray-200">{{ options.pag }}</span> de <span
                class="font-semibold text-gray-800 dark:text-gray-200">{{ options.countPag }}</span></div>
            <div>Total resultados: <span class="font-semibold text-gray-800 dark:text-gray-200">{{ (options.count)
                }}</span>
            </div>
            <div>Cantidad por pagina: </div>
            <div>
              <SelectDefault
                :id="'limit_' + options.identification"
                v-model="options.limit"
                class="pl-2"
                style="width:80px"
                :options="[5, 10, 25, 100]"
                size="small"
                :basic-select="true"
                @change="cambiarLimit"
                />
            </div>
          </div>
        </div>
        <div class="hidden md:block">
          <p class="text-sm text-gray-600 dark:text-gray-400 flex flex-inline justify-center items-center">
            Pagina <span class="font-semibold text-gray-800 dark:text-gray-200">{{ options.pag }}</span> de <span
              class="font-semibold text-gray-800 dark:text-gray-200">{{ options.countPag }}</span>, Total resultados:
            <span class="font-semibold text-gray-800 dark:text-gray-200">{{ (options.count) }}</span>
            , Cantidad por pagina: <SelectDefault
:id="'paginacion_' + options.identification" v-model="options.limit"
              class="pl-2" style="width:80px" :options="[5, 10, 25, 100]" size="small"
              :basic-select="true" @change="cambiarLimit">
            </SelectDefault>
          </p>
        </div>
        <div>
          <div class="inline-flex gap-x-2">
            <Pagination
:options="paginationOptions"
              :on-click-pag="options.search" @cambiar-pagina="paginationOptions.pag = $event; options.pag = $event">
            </Pagination>
          </div>
        </div>
      </div>
    </div>
  </slot>
</template>
<script setup lang="ts" generic="T">
import { ref, watch, type Ref } from 'vue'
import type { IconName, IDataTable, IPaginationOptions } from '@/modules/Core/interfaces'
import { getSkeleton } from '@/modules/Core/usings/generales.js'
import * as iconos from '@heroicons/vue/24/outline'
const expand: Ref<unknown> = ref({} as unknown)
const seleccionarAll = ref(false)
const props = defineProps<{
  options: IDataTable<T>
}>()
const { options } = props
const paginationOptions: Ref<IPaginationOptions> = ref({
  pag: options.pag,
  countPag: options.countPag
})
watch(options, async (nuevasPropiedades: IDataTable<T>, antiguasPropiedades: IDataTable<T>) => {
  paginationOptions.value.pag = nuevasPropiedades.pag
  paginationOptions.value.countPag = nuevasPropiedades.countPag
})
const isExpanded = (row: T) => {
  return expand.value == row
}
const expanded = (item: T) => {
  expand.value = isExpanded(item) ? null : item
}
const checkedAll = () => {
  options.seleccionados = seleccionarAll.value ? props.options.rows.map((item: any) => item[options.columnChecked || 0]) : []
}
const cambiarLimit = async () => {
  props.options.search && await props.options.search()
}
const listColor = {
  "red": ' inline-flex shrink-0 justify-center items-center size-8 rounded-full text-gray-500 hover:bg-red-100 hover:text-red-800 focus:z-10 focus:outline-none focus:ring-2 focus:ring-red-500 dark:hover:bg-red-900 dark:hover:text-red-200 dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600 ',
  "green": ' inline-flex shrink-0 justify-center items-center size-8 rounded-full text-gray-500 hover:bg-green-100 hover:text-green-800 focus:z-10 focus:outline-none focus:ring-2 focus:ring-green-500 dark:hover:bg-green-900 dark:hover:text-green-200 dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600 ',
  "blue": ' inline-flex shrink-0 justify-center items-center size-8 rounded-full text-gray-500 hover:bg-blue-100 hover:text-blue-800 focus:z-10 focus:outline-none focus:ring-2 focus:ring-blue-500 dark:hover:bg-blue-900 dark:hover:text-blue-200 dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600 '
} as Record<string, string>
</script>
